import Index from './index.vue'
import List from './components/List.vue'
// import Create from './components/Create.vue'
// import Profile from './view/Profile.vue'
// import Edit from './components/Edit.vue'


export default [
  {
    path: 'ads',
    name: 'ads',
    component: Index,
    title: 'ads',
    redirect: { name: 'ads-list' },
    children: [
      {
        path: 'list',
        name: 'ads-list',
        component: List,
      },
      // {
      //   path: 'create',
      //   name: "adImage-create",
      //   component: Create
      // },
      // {
      //   path: 'edit/:id',
      //   name: "adImage-edit",
      //   component: Edit
      // },
      // {
      //   path: 'profile/:id',
      //   name: "adImage-profile",
      //   component: Profile
      // }
    ],
    
  },
]
